import { authedJson } from '../api/client';

export type WorkspaceRole = 'OWNER' | 'ADMIN' | 'MEMBER';

export interface Workspace {
  workspaceId: string;
  name: string;
  ownerId: string;
  createdAt: number;
}

export interface InviteResult {
  workspaceId: string;
  userId: string;
  role: WorkspaceRole;
}

export interface WorkspaceMemberInfo {
  userId: string;
  email: string;
  displayName: string;
  role: WorkspaceRole;
  joinedAt: number;
}

export const workspacesApi = {
  list: (getToken: () => string | null, doRefresh: () => Promise<boolean>) =>
    authedJson<{ workspaces: Workspace[] }>('/workspaces', { method: 'GET' }, getToken, doRefresh),

  create: (name: string, getToken: () => string | null, doRefresh: () => Promise<boolean>) =>
    authedJson<Workspace>('/workspaces', { method: 'POST', body: JSON.stringify({ name }) }, getToken, doRefresh),

  invite: (
    workspaceId: string,
    email: string,
    role: WorkspaceRole,
    getToken: () => string | null,
    doRefresh: () => Promise<boolean>,
  ) =>
    authedJson<InviteResult>(
      `/workspaces/${workspaceId}/invite`,
      { method: 'POST', body: JSON.stringify({ email, role }) },
      getToken,
      doRefresh,
    ),

  listMembers: (workspaceId: string, getToken: () => string | null, doRefresh: () => Promise<boolean>) =>
    authedJson<{ members: WorkspaceMemberInfo[] }>(
      `/workspaces/${workspaceId}/members`,
      { method: 'GET' },
      getToken,
      doRefresh,
    ),
};
